import service from '@/store/services/profile-service';

const state = {
	me: '',
	session: 18000, // 5 heures en secondes
    data: {}
};

const mutations = {
	SET_RESOURCE: (state, me) => {
		state.me = me;
	},
	UPDATE_SESSION: (state) => {
		state.session = state.session - 1;
	},
	RESET_SESSION: (state) => {
		state.session = 18000;
	},
    setFiltersData(state, payload) {
        if (state.me) {
            let date
            if (state.me.data) {
                date = JSON.parse(state.me.data)
                date.factu_date = payload.month+1 + '-' + payload.year
            } else {
                date = {factu_date: payload.month+1 + '-' + payload.year}
            }
            state.me.data = JSON.stringify(date)
        }
    }
};

const actions = {
	me({commit, dispatch}, params) {
		return service.get(params)
			.then((profile) => {
				commit('SET_RESOURCE', profile.list);
			});
	},

	update({commit, dispatch}, params) {
		return service.update(params)
			.then((profile) => {
				commit('SET_RESOURCE', profile);
			});
	},

	updateSession({commit, dispatch}, params) {
		commit('UPDATE_SESSION')
	},

	resetSession({commit, dispatch}, params) {
		commit('RESET_SESSION')
	},
};

const getters = {
	me: state => state.me,
	sessionTime: state => state.session
};

const profile = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default profile;
